module.exports = __webpack_public_path__ + "img/User_Character_01.1de68dc0.png";